@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.onboarding.resources/"

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.ob_back_a11y: StringResource by lazy {
      StringResource("string:ob_back_a11y", "ob_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

@delegate:ResourceContentHash(-1_119_948_289)
internal val Res.string.ob_city_all_canada: StringResource by lazy {
      StringResource("string:ob_city_all_canada", "ob_city_all_canada", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 47, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 66),
      ))
    }

@delegate:ResourceContentHash(1_968_730_115)
internal val Res.string.ob_city_all_usa: StringResource by lazy {
      StringResource("string:ob_city_all_usa", "ob_city_all_usa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 138, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106, 63),
      ))
    }

@delegate:ResourceContentHash(-2_046_945_693)
internal val Res.string.ob_city_coming_soon: StringResource by lazy {
      StringResource("string:ob_city_coming_soon", "ob_city_coming_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 226, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170, 43),
      ))
    }

@delegate:ResourceContentHash(-306_542_878)
internal val Res.string.ob_city_locating: StringResource by lazy {
      StringResource("string:ob_city_locating", "ob_city_locating", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 274, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 266, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214, 52),
      ))
    }

@delegate:ResourceContentHash(-1_890_331_467)
internal val Res.string.ob_city_subtitle: StringResource by lazy {
      StringResource("string:ob_city_subtitle", "ob_city_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 351, 176),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 327, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267, 92),
      ))
    }

@delegate:ResourceContentHash(-2_058_539_627)
internal val Res.string.ob_city_title: StringResource by lazy {
      StringResource("string:ob_city_title", "ob_city_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 528, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 460, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 360, 53),
      ))
    }

@delegate:ResourceContentHash(-1_959_875_023)
internal val Res.string.ob_city_use_location: StringResource by lazy {
      StringResource("string:ob_city_use_location", "ob_city_use_location", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 590, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 514, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 414, 48),
      ))
    }

@delegate:ResourceContentHash(-2_049_465_387)
internal val Res.string.ob_continue: StringResource by lazy {
      StringResource("string:ob_continue", "ob_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 671, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 571, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 463, 31),
      ))
    }

@delegate:ResourceContentHash(-2_075_604_251)
internal val Res.string.ob_country_ca: StringResource by lazy {
      StringResource("string:ob_country_ca", "ob_country_ca", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 707, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 603, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 495, 29),
      ))
    }

@delegate:ResourceContentHash(-1_436_895_757)
internal val Res.string.ob_country_subtitle: StringResource by lazy {
      StringResource("string:ob_country_subtitle", "ob_country_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 745, 191),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 633, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 525, 115),
      ))
    }

@delegate:ResourceContentHash(-23_336_165)
internal val Res.string.ob_country_title: StringResource by lazy {
      StringResource("string:ob_country_title", "ob_country_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 937, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 765, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 641, 44),
      ))
    }

@delegate:ResourceContentHash(406_571_649)
internal val Res.string.ob_country_us: StringResource by lazy {
      StringResource("string:ob_country_us", "ob_country_us", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 990, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 810, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 686, 41),
      ))
    }

@delegate:ResourceContentHash(-481_935_050)
internal val Res.string.ob_done: StringResource by lazy {
      StringResource("string:ob_done", "ob_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1044, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 848, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 728, 23),
      ))
    }

@delegate:ResourceContentHash(-928_410_300)
internal val Res.string.ob_interests_change_later: StringResource by lazy {
      StringResource("string:ob_interests_change_later", "ob_interests_change_later", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1072, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 876, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 752, 85),
      ))
    }

@delegate:ResourceContentHash(2_027_499_457)
internal val Res.string.ob_interests_subtitle: StringResource by lazy {
      StringResource("string:ob_interests_subtitle", "ob_interests_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1206, 173),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 962, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 838, 97),
      ))
    }

@delegate:ResourceContentHash(-1_552_373_629)
internal val Res.string.ob_interests_title: StringResource by lazy {
      StringResource("string:ob_interests_title", "ob_interests_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1380, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1084, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 936, 50),
      ))
    }

@delegate:ResourceContentHash(-506_304_712)
internal val Res.string.ob_language_line_en: StringResource by lazy {
      StringResource("string:ob_language_line_en", "ob_language_line_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1471, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1155, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 987, 55),
      ))
    }

@delegate:ResourceContentHash(797_092_292)
internal val Res.string.ob_language_line_fa: StringResource by lazy {
      StringResource("string:ob_language_line_fa", "ob_language_line_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1527, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1211, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1043, 83),
      ))
    }

@delegate:ResourceContentHash(1_018_339_710)
internal val Res.string.ob_language_line_fr: StringResource by lazy {
      StringResource("string:ob_language_line_fr", "ob_language_line_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1611, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1295, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1127, 59),
      ))
    }

@delegate:ResourceContentHash(811_337_214)
internal val Res.string.ob_language_title: StringResource by lazy {
      StringResource("string:ob_language_title", "ob_language_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1671, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1355, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1187, 53),
      ))
    }

@delegate:ResourceContentHash(291_023_027)
internal val Res.string.ob_next: StringResource by lazy {
      StringResource("string:ob_next", "ob_next", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1753, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1413, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1241, 23),
      ))
    }

@delegate:ResourceContentHash(1_350_352_312)
internal val Res.string.ob_skip: StringResource by lazy {
      StringResource("string:ob_skip", "ob_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1781, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1441, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1265, 23),
      ))
    }

@delegate:ResourceContentHash(-1_264_204_500)
internal val Res.string.ob_slide_community_body: StringResource by lazy {
      StringResource("string:ob_slide_community_body", "ob_slide_community_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1813, 215),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1465, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1289, 147),
      ))
    }

@delegate:ResourceContentHash(1_077_938_403)
internal val Res.string.ob_slide_community_title: StringResource by lazy {
      StringResource("string:ob_slide_community_title", "ob_slide_community_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2029, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1649, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1437, 96),
      ))
    }

@delegate:ResourceContentHash(1_536_860_106)
internal val Res.string.ob_slide_discover_body: StringResource by lazy {
      StringResource("string:ob_slide_discover_body", "ob_slide_discover_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2182, 206),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1754, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1534, 142),
      ))
    }

@delegate:ResourceContentHash(1_952_258_276)
internal val Res.string.ob_slide_discover_title: StringResource by lazy {
      StringResource("string:ob_slide_discover_title", "ob_slide_discover_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2389, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1905, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1677, 95),
      ))
    }

@delegate:ResourceContentHash(1_092_746_508)
internal val Res.string.ob_slide_market_body: StringResource by lazy {
      StringResource("string:ob_slide_market_body", "ob_slide_market_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2517, 172),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2021, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1773, 128),
      ))
    }

@delegate:ResourceContentHash(1_298_130_134)
internal val Res.string.ob_slide_market_title: StringResource by lazy {
      StringResource("string:ob_slide_market_title", "ob_slide_market_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2690, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2154, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1902, 69),
      ))
    }

@delegate:ResourceContentHash(-385_127_805)
internal val Res.string.ob_step_a11y: StringResource by lazy {
      StringResource("string:ob_step_a11y", "ob_step_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2788, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2232, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1972, 44),
      ))
    }

@delegate:ResourceContentHash(-1_967_297_693)
internal val Res.string.signin_apple: StringResource by lazy {
      StringResource("string:signin_apple", "signin_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2845, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2281, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2017, 28),
      ))
    }

@delegate:ResourceContentHash(35_704_243)
internal val Res.string.signin_brand: StringResource by lazy {
      StringResource("string:signin_brand", "signin_brand", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2874, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2310, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2046, 32),
      ))
    }

@delegate:ResourceContentHash(-2_006_757_064)
internal val Res.string.signin_continue_guest: StringResource by lazy {
      StringResource("string:signin_continue_guest", "signin_continue_guest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2907, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2343, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2079, 53),
      ))
    }

@delegate:ResourceContentHash(-1_946_446_547)
internal val Res.string.signin_divider: StringResource by lazy {
      StringResource("string:signin_divider", "signin_divider", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2989, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2405, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2133, 46),
      ))
    }

@delegate:ResourceContentHash(773_564_302)
internal val Res.string.signin_email_label: StringResource by lazy {
      StringResource("string:signin_email_label", "signin_email_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3040, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2452, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2180, 46),
      ))
    }

@delegate:ResourceContentHash(1_874_284_660)
internal val Res.string.signin_email_placeholder: StringResource by lazy {
      StringResource("string:signin_email_placeholder", "signin_email_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3095, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2503, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2227, 60),
      ))
    }

@delegate:ResourceContentHash(-1_906_736_307)
internal val Res.string.signin_error_email_in_use: StringResource by lazy {
      StringResource("string:signin_error_email_in_use", "signin_error_email_in_use", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3156, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2564, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2288, 109),
      ))
    }

@delegate:ResourceContentHash(698_632_791)
internal val Res.string.signin_error_generic: StringResource by lazy {
      StringResource("string:signin_error_generic", "signin_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3306, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2690, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2398, 80),
      ))
    }

@delegate:ResourceContentHash(1_922_293_888)
internal val Res.string.signin_error_invalid_credentials: StringResource by lazy {
      StringResource("string:signin_error_invalid_credentials", "signin_error_invalid_credentials", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3427, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2783, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2479, 104),
      ))
    }

@delegate:ResourceContentHash(-1_135_859_261)
internal val Res.string.signin_error_invalid_email: StringResource by lazy {
      StringResource("string:signin_error_invalid_email", "signin_error_invalid_email", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3596, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2900, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2584, 82),
      ))
    }

@delegate:ResourceContentHash(1_987_360_052)
internal val Res.string.signin_error_network: StringResource by lazy {
      StringResource("string:signin_error_network", "signin_error_network", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3707, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2995, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2667, 92),
      ))
    }

@delegate:ResourceContentHash(-1_438_790_736)
internal val Res.string.signin_forgot: StringResource by lazy {
      StringResource("string:signin_forgot", "signin_forgot", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3864, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3100, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2760, 33),
      ))
    }

@delegate:ResourceContentHash(2_107_497_927)
internal val Res.string.signin_google: StringResource by lazy {
      StringResource("string:signin_google", "signin_google", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3930, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3134, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2794, 29),
      ))
    }

@delegate:ResourceContentHash(-1_386_743_352)
internal val Res.string.signin_join_now: StringResource by lazy {
      StringResource("string:signin_join_now", "signin_join_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3964, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3164, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2824, 35),
      ))
    }

@delegate:ResourceContentHash(-452_565_039)
internal val Res.string.signin_logo_a11y: StringResource by lazy {
      StringResource("string:signin_logo_a11y", "signin_logo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4036, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3208, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2860, 36),
      ))
    }

@delegate:ResourceContentHash(109_611_592)
internal val Res.string.signin_network_badge: StringResource by lazy {
      StringResource("string:signin_network_badge", "signin_network_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4073, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3249, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2897, 72),
      ))
    }

@delegate:ResourceContentHash(399_809_555)
internal val Res.string.signin_new_here: StringResource by lazy {
      StringResource("string:signin_new_here", "signin_new_here", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4190, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3334, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2970, 43),
      ))
    }

@delegate:ResourceContentHash(-907_711_052)
internal val Res.string.signin_password_label: StringResource by lazy {
      StringResource("string:signin_password_label", "signin_password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4266, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3386, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3014, 41),
      ))
    }

@delegate:ResourceContentHash(-907_711_052)
internal val Res.string.signin_password_placeholder: StringResource by lazy {
      StringResource("string:signin_password_placeholder", "signin_password_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4316, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3432, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3056, 47),
      ))
    }

@delegate:ResourceContentHash(1_932_586_532)
internal val Res.string.signin_privacy: StringResource by lazy {
      StringResource("string:signin_privacy", "signin_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4372, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3484, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3104, 34),
      ))
    }

@delegate:ResourceContentHash(1_730_161_881)
internal val Res.string.signin_reset_sent: StringResource by lazy {
      StringResource("string:signin_reset_sent", "signin_reset_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4423, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3531, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3139, 85),
      ))
    }

@delegate:ResourceContentHash(421_316_784)
internal val Res.string.signin_show_password_a11y: StringResource by lazy {
      StringResource("string:signin_show_password_a11y", "signin_show_password_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4601, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3661, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3225, 53),
      ))
    }

@delegate:ResourceContentHash(-487_658_837)
internal val Res.string.signin_submit: StringResource by lazy {
      StringResource("string:signin_submit", "signin_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4671, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3727, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3279, 33),
      ))
    }

@delegate:ResourceContentHash(-963_023_335)
internal val Res.string.signin_subtitle: StringResource by lazy {
      StringResource("string:signin_subtitle", "signin_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4705, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3765, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3313, 95),
      ))
    }

@delegate:ResourceContentHash(-2_006_913_825)
internal val Res.string.signin_terms: StringResource by lazy {
      StringResource("string:signin_terms", "signin_terms", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4857, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3865, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3409, 28),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.signup_back_a11y: StringResource by lazy {
      StringResource("string:signup_back_a11y", "signup_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4894, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3902, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3438, 32),
      ))
    }

@delegate:ResourceContentHash(2_059_731_068)
internal val Res.string.signup_confirm_label: StringResource by lazy {
      StringResource("string:signup_confirm_label", "signup_confirm_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4935, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3935, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3471, 52),
      ))
    }

@delegate:ResourceContentHash(-1_306_483_598)
internal val Res.string.signup_confirm_placeholder: StringResource by lazy {
      StringResource("string:signup_confirm_placeholder", "signup_confirm_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5000, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4000, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3524, 66),
      ))
    }

@delegate:ResourceContentHash(116_778_531)
internal val Res.string.signup_email_invalid: StringResource by lazy {
      StringResource("string:signup_email_invalid", "signup_email_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5103, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4079, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3591, 64),
      ))
    }

@delegate:ResourceContentHash(-2_136_266_356)
internal val Res.string.signup_have_account: StringResource by lazy {
      StringResource("string:signup_have_account", "signup_have_account", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5192, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4156, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3656, 59),
      ))
    }

@delegate:ResourceContentHash(-1_659_833_406)
internal val Res.string.signup_name_label: StringResource by lazy {
      StringResource("string:signup_name_label", "signup_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5264, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4224, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3716, 37),
      ))
    }

@delegate:ResourceContentHash(860_217_237)
internal val Res.string.signup_name_placeholder: StringResource by lazy {
      StringResource("string:signup_name_placeholder", "signup_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5334, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4266, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3754, 43),
      ))
    }

@delegate:ResourceContentHash(-82_670_877)
internal val Res.string.signup_password_hint: StringResource by lazy {
      StringResource("string:signup_password_hint", "signup_password_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5386, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4310, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3798, 64),
      ))
    }

@delegate:ResourceContentHash(684_824_636)
internal val Res.string.signup_password_mismatch: StringResource by lazy {
      StringResource("string:signup_password_mismatch", "signup_password_mismatch", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5451, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4375, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3863, 64),
      ))
    }

@delegate:ResourceContentHash(-452_565_039)
internal val Res.string.signup_sign_in: StringResource by lazy {
      StringResource("string:signup_sign_in", "signup_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5548, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4460, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3928, 34),
      ))
    }

@delegate:ResourceContentHash(-1_839_365_898)
internal val Res.string.signup_strength_fair: StringResource by lazy {
      StringResource("string:signup_strength_fair", "signup_strength_fair", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5583, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4499, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3963, 48),
      ))
    }

@delegate:ResourceContentHash(1_891_660_699)
internal val Res.string.signup_strength_strong: StringResource by lazy {
      StringResource("string:signup_strength_strong", "signup_strength_strong", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5648, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4552, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4012, 50),
      ))
    }

@delegate:ResourceContentHash(-691_750_993)
internal val Res.string.signup_strength_weak: StringResource by lazy {
      StringResource("string:signup_strength_weak", "signup_strength_weak", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5711, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4607, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4063, 48),
      ))
    }

@delegate:ResourceContentHash(-378_907_096)
internal val Res.string.signup_submit: StringResource by lazy {
      StringResource("string:signup_submit", "signup_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5772, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4664, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4112, 41),
      ))
    }

@delegate:ResourceContentHash(-325_367_351)
internal val Res.string.signup_subtitle: StringResource by lazy {
      StringResource("string:signup_subtitle", "signup_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5818, 255),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4710, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4154, 135),
      ))
    }

@delegate:ResourceContentHash(910_664_540)
internal val Res.string.signup_title: StringResource by lazy {
      StringResource("string:signup_title", "signup_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6074, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4886, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4290, 48),
      ))
    }

@delegate:ResourceContentHash(-1_972_576_045)
internal val Res.string.welcome_add_claim_business: StringResource by lazy {
      StringResource("string:welcome_add_claim_business", "welcome_add_claim_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6135, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4935, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4339, 66),
      ))
    }

@delegate:ResourceContentHash(35_704_243)
internal val Res.string.welcome_app_name: StringResource by lazy {
      StringResource("string:welcome_app_name", "welcome_app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6246, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5018, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4406, 36),
      ))
    }

@delegate:ResourceContentHash(-1_254_600_474)
internal val Res.string.welcome_continue_as_user: StringResource by lazy {
      StringResource("string:welcome_continue_as_user", "welcome_continue_as_user", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6283, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5055, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4443, 56),
      ))
    }

@delegate:ResourceContentHash(-378_907_096)
internal val Res.string.welcome_create_account: StringResource by lazy {
      StringResource("string:welcome_create_account", "welcome_create_account", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6368, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5128, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4500, 50),
      ))
    }

@delegate:ResourceContentHash(-623_155_029)
internal val Res.string.welcome_footer: StringResource by lazy {
      StringResource("string:welcome_footer", "welcome_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6423, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5183, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4551, 54),
      ))
    }

@delegate:ResourceContentHash(-2_136_266_356)
internal val Res.string.welcome_have_account: StringResource by lazy {
      StringResource("string:welcome_have_account", "welcome_have_account", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6494, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5230, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4606, 60),
      ))
    }

@delegate:ResourceContentHash(1_654_908_817)
internal val Res.string.welcome_logo_a11y: StringResource by lazy {
      StringResource("string:welcome_logo_a11y", "welcome_logo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6567, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5299, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4667, 41),
      ))
    }

@delegate:ResourceContentHash(-487_658_837)
internal val Res.string.welcome_sign_in: StringResource by lazy {
      StringResource("string:welcome_sign_in", "welcome_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6617, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5341, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4709, 35),
      ))
    }

@delegate:ResourceContentHash(1_380_439_267)
internal val Res.string.welcome_tagline: StringResource by lazy {
      StringResource("string:welcome_tagline", "welcome_tagline", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6653, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5381, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4745, 99),
      ))
    }

@delegate:ResourceContentHash(-2_006_913_825)
internal val Res.string.welcome_terms_link: StringResource by lazy {
      StringResource("string:welcome_terms_link", "welcome_terms_link", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6821, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5521, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4845, 34),
      ))
    }

@delegate:ResourceContentHash(801_295_927)
internal val Res.string.welcome_terms_prefix: StringResource by lazy {
      StringResource("string:welcome_terms_prefix", "welcome_terms_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6864, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5564, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4880, 72),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ob_back_a11y", Res.string.ob_back_a11y)
  map.put("ob_city_all_canada", Res.string.ob_city_all_canada)
  map.put("ob_city_all_usa", Res.string.ob_city_all_usa)
  map.put("ob_city_coming_soon", Res.string.ob_city_coming_soon)
  map.put("ob_city_locating", Res.string.ob_city_locating)
  map.put("ob_city_subtitle", Res.string.ob_city_subtitle)
  map.put("ob_city_title", Res.string.ob_city_title)
  map.put("ob_city_use_location", Res.string.ob_city_use_location)
  map.put("ob_continue", Res.string.ob_continue)
  map.put("ob_country_ca", Res.string.ob_country_ca)
  map.put("ob_country_subtitle", Res.string.ob_country_subtitle)
  map.put("ob_country_title", Res.string.ob_country_title)
  map.put("ob_country_us", Res.string.ob_country_us)
  map.put("ob_done", Res.string.ob_done)
  map.put("ob_interests_change_later", Res.string.ob_interests_change_later)
  map.put("ob_interests_subtitle", Res.string.ob_interests_subtitle)
  map.put("ob_interests_title", Res.string.ob_interests_title)
  map.put("ob_language_line_en", Res.string.ob_language_line_en)
  map.put("ob_language_line_fa", Res.string.ob_language_line_fa)
  map.put("ob_language_line_fr", Res.string.ob_language_line_fr)
  map.put("ob_language_title", Res.string.ob_language_title)
  map.put("ob_next", Res.string.ob_next)
  map.put("ob_skip", Res.string.ob_skip)
  map.put("ob_slide_community_body", Res.string.ob_slide_community_body)
  map.put("ob_slide_community_title", Res.string.ob_slide_community_title)
  map.put("ob_slide_discover_body", Res.string.ob_slide_discover_body)
  map.put("ob_slide_discover_title", Res.string.ob_slide_discover_title)
  map.put("ob_slide_market_body", Res.string.ob_slide_market_body)
  map.put("ob_slide_market_title", Res.string.ob_slide_market_title)
  map.put("ob_step_a11y", Res.string.ob_step_a11y)
  map.put("signin_apple", Res.string.signin_apple)
  map.put("signin_brand", Res.string.signin_brand)
  map.put("signin_continue_guest", Res.string.signin_continue_guest)
  map.put("signin_divider", Res.string.signin_divider)
  map.put("signin_email_label", Res.string.signin_email_label)
  map.put("signin_email_placeholder", Res.string.signin_email_placeholder)
  map.put("signin_error_email_in_use", Res.string.signin_error_email_in_use)
  map.put("signin_error_generic", Res.string.signin_error_generic)
  map.put("signin_error_invalid_credentials", Res.string.signin_error_invalid_credentials)
  map.put("signin_error_invalid_email", Res.string.signin_error_invalid_email)
  map.put("signin_error_network", Res.string.signin_error_network)
  map.put("signin_forgot", Res.string.signin_forgot)
  map.put("signin_google", Res.string.signin_google)
  map.put("signin_join_now", Res.string.signin_join_now)
  map.put("signin_logo_a11y", Res.string.signin_logo_a11y)
  map.put("signin_network_badge", Res.string.signin_network_badge)
  map.put("signin_new_here", Res.string.signin_new_here)
  map.put("signin_password_label", Res.string.signin_password_label)
  map.put("signin_password_placeholder", Res.string.signin_password_placeholder)
  map.put("signin_privacy", Res.string.signin_privacy)
  map.put("signin_reset_sent", Res.string.signin_reset_sent)
  map.put("signin_show_password_a11y", Res.string.signin_show_password_a11y)
  map.put("signin_submit", Res.string.signin_submit)
  map.put("signin_subtitle", Res.string.signin_subtitle)
  map.put("signin_terms", Res.string.signin_terms)
  map.put("signup_back_a11y", Res.string.signup_back_a11y)
  map.put("signup_confirm_label", Res.string.signup_confirm_label)
  map.put("signup_confirm_placeholder", Res.string.signup_confirm_placeholder)
  map.put("signup_email_invalid", Res.string.signup_email_invalid)
  map.put("signup_have_account", Res.string.signup_have_account)
  map.put("signup_name_label", Res.string.signup_name_label)
  map.put("signup_name_placeholder", Res.string.signup_name_placeholder)
  map.put("signup_password_hint", Res.string.signup_password_hint)
  map.put("signup_password_mismatch", Res.string.signup_password_mismatch)
  map.put("signup_sign_in", Res.string.signup_sign_in)
  map.put("signup_strength_fair", Res.string.signup_strength_fair)
  map.put("signup_strength_strong", Res.string.signup_strength_strong)
  map.put("signup_strength_weak", Res.string.signup_strength_weak)
  map.put("signup_submit", Res.string.signup_submit)
  map.put("signup_subtitle", Res.string.signup_subtitle)
  map.put("signup_title", Res.string.signup_title)
  map.put("welcome_add_claim_business", Res.string.welcome_add_claim_business)
  map.put("welcome_app_name", Res.string.welcome_app_name)
  map.put("welcome_continue_as_user", Res.string.welcome_continue_as_user)
  map.put("welcome_create_account", Res.string.welcome_create_account)
  map.put("welcome_footer", Res.string.welcome_footer)
  map.put("welcome_have_account", Res.string.welcome_have_account)
  map.put("welcome_logo_a11y", Res.string.welcome_logo_a11y)
  map.put("welcome_sign_in", Res.string.welcome_sign_in)
  map.put("welcome_tagline", Res.string.welcome_tagline)
  map.put("welcome_terms_link", Res.string.welcome_terms_link)
  map.put("welcome_terms_prefix", Res.string.welcome_terms_prefix)
}
